/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import type { Product as ProductCardProduct } from "@farmlands/commerce";

import PlaceholderImage from "../../../assets/images/image-placeholder.png";
import { generateImageUrl } from "../../../util/helpers";
import { CartItem } from "../../cart/storage/cart.types";
import { Product } from "../storage";

/** Shared fallback image for `@farmlands/commerce` ProductCard when the shop PDP is off. */
export const PRODUCT_CARD_PLACEHOLDER = PlaceholderImage;

/**
 * Maps a product/cart item into the @farmlands/commerce card's presentational `product` prop.
 */
export const mapItemToCardProduct = (item: Product | CartItem): ProductCardProduct => ({
  name: item.name,
  sku: item.itemNumber,
  imageUrl: item.imageUrl ?? generateImageUrl(item.itemNumber),
  imageAlt: item.name,
});
